import actionTypes from '../actionTypes';

export function saveEventTrack(data) {
	return {
		type: actionTypes.SAVE_EVENT_TRACK_INFO,
		payload: data,
	};
}
